<template>
    <div class="redarea-uploader">
        <input
            type="file"
            id="files-selection"
            multiple
            accept=".jpeg,.jpg,.heic,.heif"
            ref="filesSelection"
            @change="onFilesAdded"
        >
        <div id="low-res-uploader"></div>
        <div id="high-res-uploader"></div>
        <form
            name="low-res-upload-form"
            id="low-res-upload-form"
        >
            <input
                type="hidden"
                name="userId"
                :value="userId"
            >
            <input
                type="hidden"
                name="albumId"
                :value="albumId"
            >
        </form>
        <form
            name="high-res-upload-form"
            id="high-res-upload-form"
        >
            <input
                type="hidden"
                name="userId"
                :value="userId"
            >
            <input
                type="hidden"
                name="albumId"
                :value="albumId"
            >
        </form>

        <div
            class="col-12"
            id="drop-area"
        ></div>

        <!-- tag img per check image-orientation CSS3 support in browser -->
        <img class="d-none" />
    </div>
</template>

<script>
export default {
    name: "RedareaUploader",
    props: ["userId", "albumId", "uploader1ResizeDim", "uploader2ResizeDim"],

    data() {
        return {};
    },

    mounted: function () {
        // chiamata server per avere l'endpoint EC2 da utilizzare
        // qualora sia presente, si usa l'endpoint EC2 per l'invio delle hres (upload2Options)
        this.$api.bankendGetEC2UploaderURL().then((response) => {
            //console.log("BACKEND_GET_EC2_UPLOADER_URL", response);
            var uploadUrlEC2 = response.endpoint || "";

            var uploadUrl =
                process.env.VUE_APP_API_BASE_URL +
                process.env.VUE_APP_API_UPLOAD_PHOTO_ENDPOINT;

            window.uploader = new window.RedareaUploader("#files-selection", {
                uploadMode: "double",
                acceptedFiles: ["image/jpeg", "image/heif", "image/heic"],
                dropAreaElement: "#drop-area",
                dropAreaOptions: {
                    dictDefaultMessage: ""
                },
                uploader1Element: "#low-res-uploader",
                uploader1Options: {
                    url: uploadUrl,
                    timeout: 600000,
                    parallelUploads: 5,
                    clickable: false,
                    dictDefaultMessage: "",
                    autoProcessQueue: false,
                    createImageThumbnails: false
                },
                uploader1Resize: {
                    resize: true,
                    width: this.uploader1ResizeDim,
                    height: this.uploader1ResizeDim
                },
                uploader1AutoProcessQueue: true,
                uploader1ParamsForm: "#low-res-upload-form",

                uploader2Element: "#high-res-uploader",
                uploader2Options: {
                    //url: uploadUrl,
                    url: uploadUrlEC2 || uploadUrl,
                    timeout: 600000,
                    parallelUploads: 5,
                    clickable: false,
                    dictDefaultMessage: "",
                    autoProcessQueue: false,
                    createImageThumbnails: false
                },
                uploader2Resize: {
                    // LV: in RikordaEventi non va fatto il resize delle hres
                    resize: false,
                    width: this.uploader2ResizeDim,
                    height: this.uploader2ResizeDim
                },
                uploader2AutoProcessQueue: true,
                uploader2ParamsForm: "#high-res-upload-form",
                rotateCanvasOnResize:
                    window.RedareaUploaderHelpers.isBrowserImageOrientationActive() ===
                    false
            });

            this.$emit("uploaderMounted");
        });
    },

    methods: {
        openFilesSelection() {
            this.$refs.filesSelection.click();
        },

        onFilesAdded() {
            this.$emit("filesAdded");
        }
    },

    beforeDestroy: function () {}
};
</script>

<style scoped>
input#files-selection {
    display: none;
}

#low-res-uploader {
    display: none;
}

#high-res-uploader {
    display: none;
}

#drop-area {
    width: 100%;
    /*height: 100%;*/
    height: 75vh;
    border: none;
    flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
}

#drop-area .dz-message {
    display: none;
}
</style>
